import {Component, Input, OnInit} from '@angular/core';
import {Constants} from "../../../utils/constants";
import {DataManipulationService} from "../../../services/common/data-manipulation.service";
import {VoucherService} from "../../../services/voucher.service";
import {RestaurantService} from "../../../services/restaurant.service";
import {ProductService} from "../../../services/product.service";
import {NotificationService} from "../../../services/common/notification.service";
import {TranslateService} from "@ngx-translate/core";
import Swal from "sweetalert2";

@Component({
    selector: 'app-voucher-action',
    templateUrl: './voucher-action.component.html',
    styleUrls: ['./voucher-action.component.scss']
})
export class VoucherActionComponent implements OnInit {
    @Input() voucher: any;
    @Input() restaurants: any[] = [];
    public VOUCHER_STATUSES = Constants.VOUCHER_STATUSES;
    public isEdit = false;
    public showConvertVoucher = false;
    public currentValidity: Date;
    public selectedRestaurant: any = {};
    public giftCards = [];
    public selectedGiftCard: any = {};
    public personCount: number;
    selectedRestaurantHistoryIds: any[] = [];
    filteredGiftCards: any[] = [];

    constructor(
        private dataManipulation: DataManipulationService,
        private voucherService: VoucherService,
        private restaurantService: RestaurantService,
        private productService: ProductService,
        private toaster: NotificationService,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        this.currentValidity = new Date(this.voucher.validity);
        this.voucher.validity = new Date(this.voucher.validity);
        this.voucher.product.attachment = this.dataManipulation.oneAttachmentManipulation(this.voucher.product.attachment);
        this.dataManipulation.addNameAttributeFromFirstAndLastName(this.voucher.billingData);
        this.productService.getAllSlimGiftCard().subscribe(response => {
            this.giftCards = response;
            this.filteredGiftCards = this.giftCards;
            if (this.filteredGiftCards.length > 0) {
                this.selectedGiftCard = this.giftCards[0];
                this.personCount = this.selectedGiftCard.giftCard.minPurchaseAmount;
            }
        });
        if (this.voucher.product.restaurants.length > 0) {
            this.selectedRestaurant = this.voucher.product.restaurants[0];
        }

    }

    saveValidity() {
        this.voucherService.saveNewValidity(this.voucher).subscribe(response => {
            this.toaster.showSuccess();
            this.currentValidity = this.voucher.validity;
        });
    }

    revoke() {
        this.readFullProductNumber('voucher.revoke', (result) => {
            this.voucherService.reject(result.value).subscribe(response => {
                this.voucher.status = Constants.VOUCHER_STATUSES.REJECT;
                this.toaster.showSuccess()
            });
        });
    }

    redeem() {
        this.readFullProductNumber('voucher.redeem', (result) => {
            this.voucherService.redeem(result.value, this.selectedRestaurant.historyId).subscribe(response => {
                this.voucher.status = Constants.VOUCHER_STATUSES.USED;
                this.voucher.restaurantName = this.selectedRestaurant.name;
                this.toaster.showSuccess()
            });
        });
    }

    readFullProductNumber(btnOk: string, process: (result) => void) {
        Swal.fire({
            title: this.translate.instant('voucher.redeemConfirmText'),
            input: "text",
            inputValue: this.voucher.productNumber.substr(0, 8),
            showCancelButton: true,
            backdrop: false,
            inputAutoTrim: true,
            inputAttributes: {'maxlength': '16'},
            allowOutsideClick: false,
            confirmButtonText: this.translate.instant(btnOk),
            cancelButtonText: this.translate.instant('general.cancel'),
            confirmButtonColor: "#ff6491",
            cancelButtonColor: "#344675 ",
        }).then(result => {
            if (result.value) {
                process(result);
            }
        }).catch(error => {
            console.warn(error);
        });
    }

    convertVoucher() {
        if (!confirm(this.translate.instant('voucher.convertConfirmText'))) return;
        if (this.personCount < this.selectedGiftCard.minPurchaseAmount) {
            this.toaster.showError("voucher.minPurchaseAmountCheckFailed");
            return;
        }
        this.voucherService.convertVoucher(this.voucher, this.selectedGiftCard["id"], this.personCount).subscribe(response => {
            this.toaster.showSuccess();
            window.location.reload();
        })
    }

    convertable() {
        if (this.voucher.hasDeliveryReservation) {
            return false;
        }
        if (this.currentValidity < new Date()) {
            return false;
        }
        return true;
    }

    filterByRestaurant(historyId: any) {
        this.selectedRestaurantHistoryIds = [];
        this.selectedRestaurantHistoryIds.push(historyId);
        this.filteredGiftCards = this.giftCards.filter(giftCard => {
            const tmpList = giftCard.restaurants.filter(restaurant => {
                return this.selectedRestaurantHistoryIds.includes(restaurant.historyId);
            });
            return tmpList.length > 0;
        });
    }
}
